import { render, staticRenderFns } from "./CustomFieldsEditFormBuilderModal.vue?vue&type=template&id=0671c370&"
import script from "./CustomFieldsEditFormBuilderModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsEditFormBuilderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports